import set from 'lodash/set';
import {createSlice, PayloadAction} from '@reduxjs/toolkit';

import {BrandTypes, ChangeFieldPayload, BrandliftContext} from './types';

export const INITIAL_STATE: BrandliftContext = {
    brandType: BrandTypes.PRODUCT,
    metricLabels: {},
    metricOptions: {},
    metricPlaceholders: {},
    version: 3,
    logos: []
};

const slice = createSlice({
    name: 'context',
    initialState: INITIAL_STATE,
    reducers: {
        changeField(state, action: PayloadAction<ChangeFieldPayload>) {
            const {field, value} = action.payload;

            set(state, field, value);
        },
        changeFields(state, action: PayloadAction<Partial<BrandliftContext>>) {
            Object.assign(state, action.payload);
        },
        clearContext() {
            return INITIAL_STATE;
        },
        cancelChanges() {
            return;
        }
    }
});

const {actions, reducer} = slice;

export const {cancelChanges, changeField, changeFields, clearContext} = actions;

export default reducer;
